/**
 * HTTP layer for sales-order line items. CRUD for the items on a sales order.
 *
 * Contains:
 * - fetchOrderSaleItems / fetchOrderSaleItem: reads
 * - postOrderSaleItem / patchOrderSaleItem / deleteOrderSaleItem: writes
 */
import apiClient from '@sophocles/http-common';

const ORDER_SALE_ITEM_ENDPOINT = '/warehouse/order-sale-items';

export const fetchOrderSaleItems = queryParams =>
  apiClient.get(`${ORDER_SALE_ITEM_ENDPOINT}/`, { params: queryParams }).then(res => res.data);

export const fetchOrderSaleItem = orderSaleItemId =>
  apiClient.get(`${ORDER_SALE_ITEM_ENDPOINT}/${orderSaleItemId}/`).then(res => res.data);

export const postOrderSaleItem = data => apiClient.post(`${ORDER_SALE_ITEM_ENDPOINT}/`, data).then(res => res.data);

export const patchOrderSaleItem = (orderSaleItemId, data) =>
  apiClient.patch(`${ORDER_SALE_ITEM_ENDPOINT}/${orderSaleItemId}/`, data).then(res => res.data);

export const deleteOrderSaleItem = orderSaleItemId =>
  apiClient.delete(`${ORDER_SALE_ITEM_ENDPOINT}/${orderSaleItemId}/`);
